<template>
	<form action="/dashboard" method="get" @submit.prevent="onSubmit">
		<div class="title-container">
			<div class="title">User Log In</div>
			<div class="buttons">
				<router-link to="/forgot-password" class="button"><div class="hover-title">Forgot</div><span class="fa fa-question-circle"></span></router-link>
			</div>
		</div>

		<form-errors :errors="errors"></form-errors>

		<field-errors v-if="submitAttempted" :form="$v.form" field="email"></field-errors>
		<div class="input-container">
			<div class="input-title">Email Address</div>
			<div class="input-box"><input type="email" v-model="form.email" autocomplete="email"></div>
		</div>
		<field-errors v-if="submitAttempted" :form="$v.form" field="password"></field-errors>
		<div class="input-container">
			<div class="input-title">Password</div>
			<div class="input-box"><input type="password" v-model="form.password" autocomplete="current-password"></div>
		</div>
		<submit-button text="Log In" icon="fa-key" :loading="formSaving"></submit-button>
	</form>
</template>

<script>

import FormMixin from '@/mixins/FormMixin';
import { required, email } from 'vuelidate/lib/validators';

export default {

	props: {
		value: {
			type: Object,
			required: true,
		},
		action: {
			type: Function,
			default: () => {},
		},
	},

	mixins: [ FormMixin ],

	data() {
		return {
			form: this.value,
		};
	},

	validations: {
		form: {
			email: {
				required,
				email,
			},
			password: { required },
		},
	},

	watch: {

		form: {
			deep: true,
			handler: function(newValue) {
				this.$emit('input', newValue);
			}
		},

	},

	methods: {

		onSubmit() {
			this.submit(async () => {
				await this.action();
			});
		},

	},

};

</script>
